import { Icon } from 'ant-design-vue'

const IconFont = {
  vm: {},
  // eslint-disable-next-line no-unused-vars
  install (Vue) {
    if (this.installed) {
      return
    }
    this.installed = true

    const IconFont = Icon.createFromIconfontCN({
      scriptUrl: '//at.alicdn.com/t/font_2549064_m9sfh4kov0o.js'
    })

    Vue.component('IconFont', IconFont)
  }
}

export default IconFont
